export default "__VITE_ASSET__1aa2e5ee__"